document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('[data-categories-carousel]');

    if (!carousels.length) {
        return;
    }

    carousels.forEach((carousel) => {
        const track = carousel.querySelector('[data-categories-carousel-track]');

        if (!track || !track.children.length) {
            return;
        }

        const prevButton = carousel.querySelector('[data-categories-carousel-prev]');
        const nextButton = carousel.querySelector('[data-categories-carousel-next]');
        const counter = carousel.querySelector('[data-categories-carousel-counter]');
        const bar = carousel.querySelector('[data-categories-carousel-bar]');

        function pad(value) {
            return String(value).padStart(2, '0');
        }

        // Width of one card plus the gap — the distance a single slide travels.
        function getStep() {
            const card = track.firstElementChild;

            if (!card) {
                return 0;
            }

            const gap = parseFloat(window.getComputedStyle(track).columnGap);

            return card.getBoundingClientRect().width + (Number.isNaN(gap) ? 0 : gap);
        }

        function page(direction) {
            const step = getStep();

            if (!step) {
                return;
            }

            // Rounded, not floored: the trailing card has no gap after it, so the
            // viewport is a hair narrower than `visible * step`.
            const perView = Math.max(1, Math.round(track.clientWidth / step));

            track.scrollBy({ left: direction * step * perView, behavior: 'smooth' });
        }

        function update() {
            const maxScroll = track.scrollWidth - track.clientWidth;
            const isStatic = maxScroll <= 4;

            carousel.classList.toggle('categories-carousel--static', isStatic);

            if (bar) {
                const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
                const progress = isStatic ? 0 : Math.min(1, Math.max(0, track.scrollLeft / maxScroll));

                bar.style.width = `${(visibleRatio * 100).toFixed(2)}%`;
                bar.style.left = `${(progress * (100 - visibleRatio * 100)).toFixed(2)}%`;
            }

            const step = getStep();

            if (counter && step) {
                const total = track.children.length;
                const current = Math.min(total, Math.round(track.scrollLeft / step) + 1);

                counter.textContent = `${pad(current)} / ${pad(total)}`;
            }

            if (prevButton) {
                prevButton.disabled = track.scrollLeft <= 4;
            }

            if (nextButton) {
                nextButton.disabled = track.scrollLeft >= maxScroll - 4;
            }
        }

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                page(-1);
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                page(1);
            });
        }

        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);

        update();

        // Cards sized by a lazily-loaded image settle a frame late.
        window.setTimeout(update, 300);
    });
});
